import { render, staticRenderFns } from "./ProcessQuestion.vue?vue&type=template&id=60329845&"
import script from "./ProcessQuestion.vue?vue&type=script&lang=js&"
export * from "./ProcessQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports